export default "__VITE_ASSET__t_8mYzie__"